import { addClass, hasClass, removeClass } from "../helpers/class_helper";
import { isLeftMouseClick } from '../helpers/event_helper';

const defaults = {
  dataAttr            : 'data-tab-id',
  tabActiveClass      : 'active',
  panelActiveClass    : 'active',
  beforeCallback      : (tabId) => { return true; },
  afterCallback       : (tabId) => { return true; },
  beforeClickCallback : (tab) => { return true; },
  afterClickCallback  : (tab) => { return true; },
};

export default class Tabs {

  constructor(tabsSelector, panels, options={}) {
    this._tabs       = document.querySelectorAll(tabsSelector);
    this._panels     = document.querySelectorAll(panels);
    this._options    = Object.assign({}, defaults, options);
    this.selected    = null;

    this.activate();
    this._bindTabs();
  }

  getSelectedIndex() {
    return this.selected;
  }

  getSelected() {
    return {
      tab   : this._tabs[this.selected],
      panel : this._panels[this.selected],
    };
  }

  getTabs() {
    return this._tabs;
  }

  getNbActiveTabs() {
    let nbActiveTab = 0;
    this._tabs.forEach( tab => { // can't use reduce because _tabs is a nodelist not an array
      if (!hasClass(tab, 'disabled')) nbActiveTab++;
    });
    return nbActiveTab;
  }

  setTabs(tabsSelector) {
    this._tabs = document.querySelectorAll(tabsSelector);
  }

  activate(tabId, _callbacks={}) {
    if (!tabId)
      tabId = this._tabs[0].getAttribute(this._options.dataAttr);
    if (this.selected == null || (this.selected !== null && this._tabs[this.selected] && this._tabs[this.selected].getAttribute(this._options.dataAttr) != tabId)) {
      if (this._options.beforeCallback(tabId) && this._sendCallback(_callbacks.before)) {
        this._toggleTabs(tabId);
        this._showPanel(tabId);
        this._options.afterCallback(tabId);
        if (_callbacks.after) this._sendCallback(_callbacks.after);
      }
    }
  }

/*-- Private methods ---------------------------------------------------------*/

  _sendCallback(callback) {
    return (callback && typeof(callback) === 'function')
      ? callback.call(this)
      : true;
  }

  _toggleTabs(tabId) {
    this._tabs.forEach( tab => {
      (tab.getAttribute(this._options.dataAttr) == tabId)
        ? this._activateTab(tab)
        : this._deactivateTab(tab);
    });
  }

  _activateTab(tab) {
    addClass(tab, this._options.tabActiveClass);
  }

  _deactivateTab(tab) {
    removeClass(tab, this._options.tabActiveClass);
  }

  _showPanel(tabId) {
    this._panels.forEach( (panel, index) => {
      if (panel.getAttribute(this._options.dataAttr) == tabId) {
        addClass(panel, this._options.panelActiveClass);
        this.selected = index;
      } else {
        removeClass(panel, this._options.panelActiveClass);
      }
    });
  }

  _bindTabs() {
    this._tabs.forEach ( tab => {
      tab.addEventListener('mousedown', event => {
        if (isLeftMouseClick(event) && !hasClass(tab, 'disabled')) {
          if (this._options.beforeClickCallback(tab)) {
            this.activate(tab.getAttribute(this._options.dataAttr));
            this._options.afterClickCallback(tab);
          }
        } // Else do nothing
      });
    });
  }
}



// WEBPACK FOOTER //
// ./assets/javascripts/libs/tabs.js